import {
    IProductionLine,
    IWorkOrder,
    ICleaning,
} from "@/models";

interface IProductionLineState {
    productionLines: IProductionLine[];
    workOrders: IWorkOrder[];
    notifications: string[];
    lastCleanings: ICleaning[];
}

const initialState: IProductionLineState = {
    productionLines: [],
    workOrders: [],
    notifications: [],
    lastCleanings: [],
};

export { IProductionLineState, initialState };
